var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#00A0AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0832 24.75C34.0832 27.0051 32.255 28.8333 29.9998 28.8333C27.7447 28.8333 25.9165 27.0051 25.9165 24.75C25.9165 22.4948 27.7447 20.6666 29.9998 20.6666C32.255 20.6666 34.0832 22.4948 34.0832 24.75Z",
    fill: "#EEE82C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 35.25C37 37.5051 33.866 39.3333 30 39.3333C26.134 39.3333 23 37.5051 23 35.25C23 32.9948 26.134 31.1666 30 31.1666C33.866 31.1666 37 32.9948 37 35.25Z",
    fill: "#EEE82C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3092 21.8334C24.5163 21.8334 24.7184 21.8537 24.9136 21.8924C24.4381 22.7369 24.1668 23.7118 24.1668 24.75C24.1668 25.763 24.425 26.7157 24.8792 27.5458C24.6947 27.5802 24.5041 27.5982 24.3092 27.5982C22.6591 27.5982 21.3214 26.3077 21.3214 24.7158C21.3214 23.1239 22.6591 21.8334 24.3092 21.8334Z",
    fill: "#EEE82C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3554 38.1503C21.6928 37.3583 21.2502 36.3864 21.2502 35.25C21.2502 34.1484 21.6662 33.2014 22.2952 32.4229C20.0731 32.5953 18.3335 33.8106 18.3335 35.2843C18.3335 36.7719 20.1037 37.9962 22.3554 38.1503Z",
    fill: "#EEE82C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8332 24.75C35.8332 25.763 35.575 26.7157 35.1208 27.5458C35.3053 27.5802 35.4959 27.5982 35.6908 27.5982C37.3409 27.5982 38.6786 26.3077 38.6786 24.7158C38.6786 23.1239 37.3409 21.8334 35.6908 21.8334C35.4837 21.8334 35.2816 21.8537 35.0864 21.8924C35.5619 22.7369 35.8332 23.7118 35.8332 24.75Z",
    fill: "#EEE82C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6446 38.1503C39.8963 37.9962 41.6665 36.7719 41.6665 35.2843C41.6665 33.8106 39.9269 32.5953 37.7047 32.4229C38.3338 33.2014 38.7498 34.1484 38.7498 35.25C38.7498 36.3864 38.3072 37.3583 37.6446 38.1503Z",
    fill: "#EEE82C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#CCECEF",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.192cdbf2a2b328b1118948959abf2240.svg";
export { ForwardRef as ReactComponent };